import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './TierBadge.css';

const TierBadge = ({ onClick, showUpgrade = true }) => {
  const { currentTier, tierInfo, canUpgrade, setShowPricing } = useTheme();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      setShowPricing(true);
    }
  };

  return (
    <div className={`tier-badge-container ${currentTier}`}>
      <button
        className={`tier-badge ${currentTier}`}
        onClick={handleClick}
        title="View plans"
      >
        <span className="tier-badge-name">{tierInfo.name}</span>
      </button>

      {showUpgrade && canUpgrade() && (
        <button
          className="upgrade-link"
          onClick={handleClick}
        >
          Upgrade
        </button>
      )}
    </div>
  );
};

export default TierBadge;
